import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { AuthorNote } from './components/AuthorNote';
import { ProblemSolution } from './components/ProblemSolution';
import { MethodSection } from './components/MethodSection';
import { ChapterPreviews } from './components/ChapterPreviews';
import { FAQSection } from './components/FAQSection';
import { ResourcesSection } from './components/ResourcesSection';
import { FinalCTA } from './components/FinalCTA';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen w-full bg-cream font-body selection:bg-anger/20 selection:text-anger" data-id="element-0">
      <HeroSection data-id="element-1" />
      <AuthorNote data-id="element-2" />
      <ProblemSolution data-id="element-3" />
      <MethodSection data-id="element-4" />
      <ChapterPreviews data-id="element-5" />
      <FAQSection data-id="element-6" />
      <ResourcesSection data-id="element-7" />
      <FinalCTA data-id="element-8" />
    </div>;
}